import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const SweFlag = ({ width = 22, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="3.14282" width="22" height="15.7143" rx="4" fill="white" />
      <mask
        id="mask0_1879_17345"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="3"
        width="22"
        height="16"
      >
        <rect y="3.14282" width="22" height="15.7143" rx="4" fill="white" />
      </mask>
      <g mask="url(#mask0_1879_17345)">
        <rect y="3.14282" width="22" height="15.7143" fill="#157CBB" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 12.5714H6.28571V18.8571H9.42857V12.5714H22V9.42854H9.42857V3.14282H6.28571V9.42854H0V12.5714Z"
          fill="#FFD34D"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
